import { BasePage } from '@/components/ui/base-page'

export function LectuPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add LectuPage specific content here */}
    </BasePage>
  )
}